import { isEmptyString } from '@/utils/string';
import type { SupportFormDiagnostics } from '../types';

/**
 * Combines the customer's description with a diagnostic snapshot into the single body the support
 * request endpoint accepts.
 *
 * The customer's own words go first — support reads those before the measurements — followed by
 * the readable digest and then the verbatim payload for tooling to parse.
 */
export function composeGoalWithDiagnostics(goal: string, diagnostics: SupportFormDiagnostics | undefined): string {
  if (diagnostics == null) return goal;

  const sections = [
    goal.trim(),
    `--- ${diagnostics.label} diagnostics (attached automatically) ---`,
    diagnostics.summary.trim(),
    isEmptyString(diagnostics.payload) ? null : diagnostics.payload.trim(),
  ].filter((section) => section != null && !isEmptyString(section));

  return sections.join('\n\n');
}
